import { recordEventWrapper } from '..';

const banner = () => ({
  onClickBanner: (description: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action:
        'mutual fund dashboard | banner',
      label: `${description}`,
    });
  },
});

export default banner;
